module.exports = __webpack_public_path__ + "static/media/caffe.03c181cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/backends/caffe.svg
// module id = 315
// module chunks = 0